import { Maybe } from '@types'
import { THeaderType } from 'components/Header/Header'
import LinkWithLocale from 'components/LinkWithLocale'
import { TLocaleCode } from 'constants/locales'
import React, { FC } from 'react'
import { BadgeType } from 'src/types'
import styled from 'styled-components'
import BadgeWarning from 'ui/Badge'
import BadgeDropdown from '../BadgeDropdown'

const NavItem: FC<IOwnProps> = ({
  to,
  badgeType,
  iconLink,
  name,
  warning,
  withLocale = true,
  type,
  onClose,
  includeLangsArr,
}) => {
  // const currentWithLocale = to === '/crypto-alerts' ? false : withLocale
  const isBlank = name === 'Video tutorials'
  return (
    <NavLink
      target={isBlank ? '_blank' : undefined}
      onClick={onClose}
      $type={type}
      to={to}
      withLocale={withLocale}
      includeLangsArr={includeLangsArr}>
      {iconLink && <IconContainer>{iconLink}</IconContainer>}
      {name}
      <BadgeContainer $type={type}>
        <BadgeDropdown theme={type} type={badgeType} />
      </BadgeContainer>
      {warning && <BadgeWarningWithMargin>{warning}</BadgeWarningWithMargin>}
    </NavLink>
  )
}

export default NavItem

interface IOwnProps {
  to: string
  name?: string
  warning?: string | null
  withLocale?: Maybe<boolean>
  type: THeaderType
  iconLink?: JSX.Element
  badgeType?: BadgeType | null
  onClick: void | (() => void)
  includeLangsArr?: TLocaleCode[]
}

const NavLink = styled(LinkWithLocale).attrs(() => ({
  role: 'button',
}))<{ $type: THeaderType }>`
  display: flex;
  color: ${({ theme: { colors }, $type }) => ($type === 'primary' ? colors.newDarkColor.softNavy : colors.lightBlue)};
  font-weight: 600;
  font-size: 14px;

  padding: 17px 40px;
`

const BadgeContainer = styled.div<{ $type: THeaderType }>`
  display: block;
  margin-inline-start: 8px;
`

const IconContainer = styled.div`
  width: 24px;
  height: 24px;
  margin-inline-end: 26px;
`

const BadgeWarningWithMargin = styled(BadgeWarning)`
  margin-inline-start: 0.5em;
`

interface IOwnProps {
  to: string
  name?: string
  warning?: string | null
  withLocale?: Maybe<boolean>
  type: THeaderType
  iconLink?: JSX.Element
  badgeType?: BadgeType | null
  onClose?: () => void
  includeLangsArr?: TLocaleCode[]
}
